module.exports = __webpack_public_path__ + "img/sld_grid_ta1_disable.2b35dcac.svg";